import React, { useState } from "react";
import axios from "axios"; // Tambahkan Axios
import { useNavigate } from "react-router-dom"; // Gunakan useNavigate untuk navigasi
import "./Emaillog.css";

const EmailLog = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate(); // Inisialisasi useNavigate

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Email dan password harus diisi!");
      return;
    }

    try {
      const response = await axios.post(
        "https://database.kopicast.web.id/emaillog.php",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setSuccess("Login berhasil!");
        setError("");
        // Simpan token di local storage jika diperlukan
        localStorage.setItem("userToken", response.data.token);
        // Redirect ke halaman utama
        window.location.href = "https://kopicast.web.id/";
      } else {
        setError(response.data.message || "Email atau password salah!");
        setSuccess("");
      }
    } catch (err) {
      setError("Terjadi kesalahan saat menghubungi server!");
      setSuccess("");
    }
  };

  return (
    <div className="email-login-container">
      <div className="emaillogin-box">
        <h2>Login dengan Email</h2>
        {error && (
          <div className="error-message">
            {error}
            <div className="error-options">
              <a href="https://wa.me/6285156913813" target="_blank" rel="noopener noreferrer">
                Hubungi Admin
              </a>
              <button onClick={() => navigate("/")}>Login Dengan Username</button>
            </div>
          </div>
        )}

        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Masukkan Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Masukkan Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p className="register-link">
          Belum punya akun? <a href="/register">Daftar di sini</a>
        </p>
      </div>
    </div>
  );
};

export default EmailLog;
